import { message } from 'antd';
import { paymentSystem } from './helper';
import { serverFetch } from '../server';

export const shouldOpenPaymentWindow = (system) =>
    system === paymentSystem.YooKassa && window.self !== window.top;

export const preparePaymentWindow = (system) => {
    if (!shouldOpenPaymentWindow(system)) return null;

    const paymentWindow = window.open('', '_blank');
    if (!paymentWindow) return null;

    paymentWindow.document.title = 'Переход к оплате';
    paymentWindow.document.body.innerHTML =
        '<p style="font-family: sans-serif; padding: 24px;">Подготавливаем страницу оплаты...</p>';
    return paymentWindow;
};

export const closePaymentWindow = (paymentWindow) => {
    if (paymentWindow && !paymentWindow.closed) paymentWindow.close();
};

export const navigateToPayment = (url, system, paymentWindow) => {
    if (!shouldOpenPaymentWindow(system)) {
        window.location.href = url;
        return true;
    }

    const targetWindow = paymentWindow && !paymentWindow.closed
        ? paymentWindow
        : window.open('', '_blank');

    if (!targetWindow) return false;

    targetWindow.opener = null;
    targetWindow.location.replace(url);
    return true;
};

// Получить ссылку на оплату продажи и перейти к ней. paymentWindowRef - ref на заранее открытое окно
export const paySale = (user, saleId, system, autopay, paymentWindowRef) =>
    serverFetch('payment/sale', { method: 'POST', bodyData: { saleId, paymentSystem: system, autopay } }, user)
        .then((data) => {
            window.parent.postMessage({ sender: 'proffit', height: '800px' }, '*');
            const opened = navigateToPayment(data, system, paymentWindowRef.current);
            paymentWindowRef.current = null;
            if (!opened) message.error('Разрешите всплывающие окна для перехода к оплате');
        })
        .catch((data) => {
            closePaymentWindow(paymentWindowRef.current);
            paymentWindowRef.current = null;
            message.error(data.UserMessage);
        });
